import { useMemo } from "react";
import { useTable, useBlockLayout, useResizeColumns } from "react-table";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import BTableCell from "../tables/BTableCell";
import BTableCellWithLink from "../tables/BTableCellWithLink";
import "./BTableRenderer.css";

function BTableRendrer({
  url,
  spacePerColumn,
  columns,
  data,
  addOrdering,
  title,
  ordering,
  maxNmbOfChars,
  isReadOnly,
}) {
  const defaultColumn = useMemo(() => {
    const rightScrollbarWidth = 15;

    let columnsWidths = {
      minWidth: 150,
      maxWidth: 1000,
    };

    if (spacePerColumn !== 0) {
      columnsWidths = {
        ...columnsWidths,
        width: spacePerColumn - rightScrollbarWidth,
      };
    }

    return columnsWidths;
  }, [spacePerColumn]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
    },
    useBlockLayout,
    useResizeColumns
  );

  const showArrowBasedOnOrdering = (field) => {
    field = field.replace(/([A-Z])/g, "_$1").toLowerCase();

    if (ordering.includes(field)) {
      return <IoIosArrowUp color="white" />;
    } else if (ordering.includes(`-${field}`)) {
      return <IoIosArrowDown color="white" />;
    }
    return null;
  };

  const makeFirstLetterLowerCase = (phrase) => {
    return phrase.charAt(0).toLowerCase() + phrase.slice(1);
  };

  return (
    <>
      <div className="w-full mt-2 overflow-x-scroll">
        <div {...getTableProps()} className="table border border-gray-300">
          <div className="w-full bg-blue-accent">
            {headerGroups.map((headerGroup) => (
              <div {...headerGroup.getHeaderGroupProps()} className="tr">
                {headerGroup.headers.map((column) => (
                  <div
                    {...column.getHeaderProps()}
                    className="th m-0 relative p-2 font-bold text-white"
                  >
                    <div className="flex justify-between items-center">
                      {/* sortowanie tylko po kliknięciu w sam tytuł kolumny */}
                      <button
                        type="button"
                        className="text-left leading-tight focus:outline-none bg-transparent p-0 m-0"
                        onClick={() => addOrdering(column.id)}
                      >
                        {column.render("Header")}
                      </button>

                      {showArrowBasedOnOrdering(column.id)}
                    </div>

                    {/* uchwyt do zmiany szerokości kolumny */}
                    <div
                      {...column.getResizerProps()}
                      className={`resizer ${column.isResizing ? "isResizing" : ""}`}
                    />
                  </div>
                ))}
              </div>
            ))}
          </div>

          <div {...getTableBodyProps()} className="overflow-auto h-60vh w-full">
            {rows.map((row) => {
              prepareRow(row);
              return (
                <div {...row.getRowProps()} className="tr hover:bg-gray-200">
                  {row.cells.map((cell) => {
                    if (cell.column.id == "id" && !isReadOnly) {
                      return (
                        <BTableCellWithLink
                          to={`${makeFirstLetterLowerCase(title)}/${row.original.id}`}
                          cell={cell}
                        />
                      );
                    }

                    // brak maxChars – nie ucinamy w JS
                    return <BTableCell isReadOnly={isReadOnly} cell={cell} />;
                  })}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}

export default BTableRendrer;
